// src/components/forms/fieldsConfig/index.js
// Export individuel depuis chaque fichier

// Client
export { 
  clientCreationFields, 
  formatClientData, 
  prepareClientFormData,
  validateClientForm 
} from './clientFields';

// Devis
export { 
  devisCreationFields, 
  devisUpdateFields, 
  devisCalculFields,
  formatDevisData, 
  prepareDevisFormData,
  validateDevisForm 
} from './devisFields';

// Bon de commande
export { 
  bonCommandeCreationFields, 
  bonCommandeUpdateFields, 
  bonCommandeReceptionFournisseurFields,
  formatBonCommandeData, 
  prepareBonCommandeFormData,
  validateBonCommandeForm 
} from './bonCommandeFields';

// Demande de prix
export { 
  demandePrixCreationFields, 
  demandePrixUpdateFields, 
  demandePrixReponseFields,
  formatDemandePrixData, 
  prepareDemandePrixFormData,
  validateDemandePrixForm 
} from './demandePrixFields';

// Fournisseur
export { 
  fournisseurCreationFields, 
  fournisseurUpdateFields,
  formatFournisseurData, 
  prepareFournisseurFormData,
  validateFournisseurForm 
} from './fournisseurFields';

// Produit
export { 
  produitCreationFields, 
  formatProduitData, 
  prepareProduitFormData,
  validateProduitForm,
  getProduitCreationFields,
  loadCategories,
  loadSuppliers 
} from './produitFields';

// Catégorie
export { 
  categorieCreationFields, 
  categorieUpdateFields,
  formatCategorieData, 
  prepareCategorieFormData,
  validateCategorieForm 
} from './categorieFields';

// Import pour l'objet global
import clientFields from './clientFields';
import devisFields from './devisFields';
import bonCommandeFields from './bonCommandeFields';
import demandePrixFields from './demandePrixFields';
import fournisseurFields from './fournisseurFields';
import produitFields from './produitFields';
import categorieFields from './categorieFields';

// Objet global pour compatibilité
const fieldsConfig = {
  client: clientFields,
  devis: devisFields,
  bonCommande: bonCommandeFields,
  demandePrix: demandePrixFields,
  fournisseur: fournisseurFields,
  produit: produitFields,
  categorie: categorieFields
};

export default fieldsConfig;